import { useSelector } from 'react-redux';
import { LicenseInfo } from '@mui/x-license';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import themes from 'themes';
import Router from 'routes';

const App = () => {
    const customization = useSelector((state) => state.customization);
    LicenseInfo.setLicenseKey(
        'fa87ffd3fe82c15c287708722ca59cc0Tz0xMzQwMTEsRT0xODI0MTYzMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI='
    );

    return (
        <ThemeProvider theme={themes(customization)}>
            <BrowserRouter>
                <Router />
                <ToastContainer />
            </BrowserRouter>
        </ThemeProvider>
    );
};

export default App;
